<template>
	<el-empty description="请在电脑上打开"></el-empty>
</template>

<script>
export default {
	name: "index"
}
</script>

<style scoped>

</style>
